<template style="height: 100%;">
  <div class="CommonContentSingle-gray sfr">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="from" class="demo-form-inline">
          <el-form-item label="账号或姓名搜索">
            <el-input v-model="from.Content" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chaxun">查询</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main>
        <el-button type="primary" @click="xinzeng">新增权限</el-button>
        <el-table ref="multipleTable" v-loading="wloadings" :data="tableData" style="width: 100%; margin-top: 10px;">
          <el-table-column label="序号" min-width="20px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.UserName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="账号">
            <template slot-scope="scope">
              <span>{{ scope.row.UserID }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.Remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.AuthState == 1">已授权</span>
              <span v-else>未授权</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="shanchju(scope.row)">删除授权</el-button>
              <el-button type="primary" size="mini" @click="xiugai(scope.row)">修改授权</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination :current-page.sync="currentPage1" @current-change="handleCurrentChange" :page-size="10"
            layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
      </el-main>
      <el-dialog title="添加权限" width="80%" :visible.sync="outerVisible">
        <el-header>
          <el-form :inline="true" :model="from2" class="demo-form-inline">
            <el-form-item label="账号或姓名搜索">
              <el-input v-model="from2.Content2" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="chaxun2">查询</el-button>
            </el-form-item>
          </el-form>
        </el-header>
        <el-container>
          <el-table ref="multipleTable" v-loading="wloadings" :data="tableData2" style="width: 100%; margin-top: 10px;">
            <el-table-column label="序号" min-width="20px" align="left">
              <template slot-scope="scope" center>
                {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.RealName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="账号">
              <template slot-scope="scope">
                <span>{{ scope.row.UserID }}</span>
              </template>
            </el-table-column>
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.SexCN }}</span>
              </template>
            </el-table-column>
            <el-table-column label="生日">
              <template slot-scope="scope">
                <span>{{ scope.row.Birthday }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="shezhi(scope.row)">设置权限</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-container>
        <div class="block">
          <el-pagination :current-page.sync="currentPage2" @current-change="handleCurrentChange2" :page-size="10"
            layout="total, prev, pager, next" :total="Counts2"></el-pagination>
        </div>
        <el-dialog width="50%" title="设置" :visible.sync="innerVisible" append-to-body>
          <el-form ref="form" :model="from3" label-width="80px">
            <el-form-item label="开始时间">
              <el-date-picker v-model="from3.StartDate" value-format="yyyy-MM-dd" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker v-model="from3.EndDate" value-format="yyyy-MM-dd" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="from3.Remark"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即创建</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
        </div>
      </el-dialog>
      <el-dialog width="50%" title="修改授权" :visible.sync="innerVisible4" append-to-body>
        <el-form ref="form" :model="from4" label-width="80px">
          <el-form-item label="开始时间">
            <el-date-picker v-model="from4.StartDate" value-format="yyyy-MM-dd" type="datetime" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="from4.EndDate" value-format="yyyy-MM-dd" type="datetime" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="from4.Remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="xgonSubmit">立即修改</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xiugaodata: '',
      neirong: '',
      dialogVisible: false,
      Counts: 0,
      Counts2: 0,
      currentPage1: 1,
      currentPage2: 1,
      pageIndex: 1,
      value1: '1',
      group: '',
      innerVisible4: false,
      wloadings: true,
      tableData: [],
      tableData2: [],
      outerVisible: false,
      innerVisible: false,
      pageIndexs: 1,
      from: {
        Content: '',
      },
      from2: {
        Content2: '',
      },
      from3: {
        StartDate: '',
        EndDate: '',
        Remark: '',
      },
      from4: {
        StartDate: '',
        EndDate: '',
        Remark: '',
      },
    }
  },

  components: {

  },
  methods: {
    xiugai(val) {
      this.xiugaodata = val
      this.from4.StartDate = val.StartDate
      this.from4.EndDate = val.EndDate
      this.from4.Remark = val.Remark
      this.innerVisible4 = true
    },
    onSubmit() {
      this.$Http_Post('SystemSetting/AddAuthorize', { "FuncType": "PublicityAuth", "UserID": this.neirong.UserID, "StartDate": this.from3.StartDate, "EndDate": this.from3.EndDate, "AuthState": "1", "Remark": this.from3.Remark }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.innerVisible = false
          this.from3.StartDate = ""
          this.from3.EndDate = ""
          this.from3.Remark = ""
        } else {
          this.Global.request_failure(res.Message);
        }
      },)
    },
    xgonSubmit() {
      this.$Http_Post('SystemSetting/UpdateAuthorize', { "AuthorizeID": this.xiugaodata.AuthorizeID, "UserID": this.xiugaodata.UserID, "StartDate": this.from4.StartDate, "EndDate": this.from4.EndDate, "AuthState": 1, "Remark": this.from4.Remark }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.innerVisible4 = false
          this.loading(this.pageIndex, this.from.Content);
        } else {
          this.Global.request_failure(res.Message)
        }
      },)
    },
    chaxun() {//查询
      this.loading(0, this.from.Content);
    },
    chaxun2() {//查询
      this.loading2(0, this.from2.Content2);
    },
    shezhi(row) {
      this.innerVisible = true
      this.neirong = row
    },
    shanchju(row) {
      this.$Http_Post('SystemSetting/DeleteAuthorize', { "AuthorizeID": row.AuthorizeID, "UserID": row.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.loading(this.pageIndex, this.from.Content);
        } else {
          this.Global.request_failure(res.Message)
        }
      },)
    },
    xinzeng() {
      this.outerVisible = true
      this.loading2(0, "1");
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.loading(this.pageIndex, this.from.Content);
    },
    handleCurrentChange2(val) {
      this.pageIndex = val
      this.loading2(this.pageIndex, this.from2.Content2);
    },
    tianjia() {
    },

    loading(pageIndex, Content) {
      this.$Http_Post('SystemSetting/GetAuthorizeList', { "Content": Content, "FuncType": "PublicityAuth", "pageSize": 10, "pageIndex": pageIndex }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data
          this.Counts = Number(res.Counts);
          this.wloadings = false
        } else {
          this.wloadings = false;
        }
      },)
    },
    loading2(pageIndex, Content) {
      this.$Http_Post('/User/GetUserListByAccountAndName', { "Content": Content, "FuncType": "PublicityAuth", "pageSize": 10, "pageIndex": pageIndex }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData2 = res.Data
          this.Counts2 = Number(res.Counts);
          this.wloadings = false
        } else if (res.Code == -1) {
          this.tableData2 = res.Data
          this.Global.request_failure(res.Message)
        } else {
          this.wloadings = false;
        }
      },)
    },
  },
  mounted() {
    this.loading(1, this.from.Content);
  },
  watch: {
    //监听
    $route() {
      if (this.$route.name == 'DropDownMng_WorkGroup') {
        this.pageName = '工作小组'
        this.keyType = 'WorkGroup'
      } else if (this.$route.name == 'DropDownMng_MaterialLabe') {
        this.pageName = '标签'
        this.keyType = 'MaterialLabe'
      }
    },
  },
}
</script>
<style>
.cell {
  text-align: center;
}

.sfr .block {
  float: right;
  margin-top: 10px;
}
</style>

